enum AccountType {
  BUSINESS = 30,
}

const allCases = [AccountType.BUSINESS];

export default AccountType;
